export const GET_REFERREES_LIST_START = 'GET_REFERREES_LIST_START';
export const GET_REFERREES_LIST_SUCCESS =
  'GET_REFERREES_LIST_SUCCESS';
export const GET_REFERREES_LIST_ERROR = 'GET_REFERREES_LIST_ERROR';
